import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { authApi } from "../../../api/api";

const VerifyEmail = () => {
  const navigate = useNavigate();
  const verificationAttempted = useRef(false);
  const [verificationStatus, setVerificationStatus] = useState<
    "loading" | "success" | "error"
  >("loading");

  useEffect(() => {
    const verifyEmailToken = async () => {
      // Skip if already attempted
      console.log(
        "verificationAttempted.current",
        verificationAttempted.current
      );
      if (verificationAttempted.current) return;
      verificationAttempted.current = true;

      try {
        const path = window.location.pathname;
        const token = path.split("/verify_email/")[1];

        if (!token) {
          setVerificationStatus("error");
          return;
        }

        const response = await authApi.verifyEmail(token);

        if (response.status === 200) {
          setVerificationStatus("success");
          setTimeout(() => {
            navigate("/login");
          }, 3000);
        } else {
          setVerificationStatus("error");
        }
      } catch (error) {
        console.error("Email verification failed:", error);
        setVerificationStatus("error");
      }
    };

    verifyEmailToken();
  }, [navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4">
      {verificationStatus === "loading" && <div>Verifying your email...</div>}
      {verificationStatus === "success" && (
        <div className="text-green-600">
          Email verified successfully! Redirecting to login...
        </div>
      )}
      {verificationStatus === "error" && (
        <div className="text-red-600">
          Failed to verify email. Please try again or contact support.
        </div>
      )}
    </div>
  );
};

export default VerifyEmail;
